import { Component } from '@angular/core';
import { ActivatedRoute, NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import * as NavigationActions from './store/common/navigation/navigation.actions';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { StorageService } from './shared/services/global/storage.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'North Starlines';
  public onlineOffline: boolean = navigator.onLine;
  submitting = false;
  loader = this.loadingBar.useRef();

  constructor(private router: Router,
    private store: Store,
    private loadingBar: LoadingBarService,
    private storageService: StorageService,
    private route: ActivatedRoute) {

    this.renderScript();

    router.events.subscribe((val) => {

      if (val instanceof NavigationStart) {
        // this.loader.start();
        this.store.dispatch(NavigationActions.showSpinner({}));
        this.storageService.setLocalStorage('last-page-visited', val.url);
      }

      if (val instanceof NavigationError) {
        setTimeout(() => {
          this.store.dispatch(NavigationActions.hideSpinner({}));
          //this.loader.stop();
        }, 500)
      }

      if (val instanceof NavigationCancel) {
        setTimeout(() => {
          this.store.dispatch(NavigationActions.hideSpinner({}));
          // this.loader.stop();
        }, 500)
      }

      if (val instanceof NavigationEnd) {
        setTimeout(() => {
          this.store.dispatch(NavigationActions.hideSpinner({}));
          window.scrollTo(0, 0);
          //this.loader.stop();
        }, 500)
      }
    });

    window.addEventListener('online', () => {
      this.onlineOffline = true;
      setTimeout(() => {
        this.store.dispatch(NavigationActions.hideSpinner({}));
      }, 1000)
    });

    window.addEventListener('offline', () => {
      this.onlineOffline = false;
      setTimeout(() => {
        this.store.dispatch(NavigationActions.hideSpinner({}));
      }, 1000)
    });
  }

  renderScript() {
    const googleMapScript: HTMLScriptElement = document.createElement('script');
    googleMapScript.async = true;
    googleMapScript.src = 'https://maps.googleapis.com/maps/api/js?center=0,0&zoom=1&libraries=geometry&sensor=false&key=' + environment.googleMayKey;
    document.head.prepend(googleMapScript);

  }
}
